import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { fetchOrganizations } from '../../store/slices/organizationsSlice';
import { getFilteredRoles } from '../../utils/helpers';

interface UserFiltersProps {
  onSearchChange: (search: string) => void;
  onStatusChange: (status: string) => void;
  onRoleChange: (role: string) => void;
  onOrgChange: (orgId: string) => void;
  currentFilters: {
    search: string;
    status: string;
    role: string;
    org_id?: string;
  };
  currentUserRole?: string;
}

const UserFilters: React.FC<UserFiltersProps> = ({
  onSearchChange,
  onStatusChange,
  onRoleChange,
  onOrgChange,
  currentFilters,
  currentUserRole,
}) => {
  const dispatch = useAppDispatch();
  const { organizations } = useAppSelector((state) => state.organizations);

  useEffect(() => {
    dispatch(fetchOrganizations({
      skip: 0,
      limit: 100,
    }));
  }, [dispatch]);

  const filteredRoles = getFilteredRoles(currentUserRole);

  return (
    <div className="flex flex-wrap gap-4">
      <div className="flex-1 min-w-[200px]">
        <input
          type="text"
          placeholder="Search users..."
          value={currentFilters.search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="block w-full px-4 py-2 rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400"
        />
      </div>
      <div className="min-w-[150px]">
        <select
          value={currentFilters.status}
          onChange={(e) => onStatusChange(e.target.value)}
          className="block w-full px-4 py-2 rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 cursor-pointer"
        >
          <option value="">All Statuses</option>
          <option value="active">Active</option>
          <option value="disabled">Disabled</option>
        </select>
      </div>
      <div className="min-w-[150px]">
        <select
          value={currentFilters.role}
          onChange={(e) => onRoleChange(e.target.value)}
          className="block w-full px-4 py-2 rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 cursor-pointer"
        >
          {filteredRoles.map((role) => (
            <option key={role.value} value={role.value}>
              {role.label}
            </option>
          ))}
        </select>
      </div>
      <div className="min-w-[200px]">
        <select
          value={currentFilters.org_id || ''}
          onChange={(e) => onOrgChange(e.target.value)}
          className="block w-full px-4 py-2 rounded-xl bg-light-card dark:bg-dark-card border border-light-border dark:border-dark-border text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500 dark:focus:ring-primary-400 cursor-pointer"
        >
          <option value="">All Organizations</option>
          {organizations?.items.map((org) => (
            <option key={org.org_id} value={org.org_id}>
              {org.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default UserFilters;
